import { Table, TableContainer } from "@mui/material";

import DeleteDialog from "../DeleteUserDialog/DeleteDialog";
import { useGetOrgUsers } from "../services/useGetOrgUsers";
import Context from "./context";
import SkeletonTable from "./SkeletonTable";
import useTableActionsStore from "./store";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

// ----------------------------------------------------------------------

export const UsersTable = () => {
	const [state, actions] = useTableActionsStore();

	const { rows, isLoading } = useGetOrgUsers();

	return (
		<TableContainer>
			{isLoading && <SkeletonTable />}
			{!isLoading && (
				<Context.Provider value={{ state, actions }}>
					<Table size='small'>
						<TableHeader />
						<TableBody data={rows} />
					</Table>
					<DeleteDialog />
				</Context.Provider>
			)}
		</TableContainer>
	);
};

export default UsersTable;
